import { API } from "../../apiSlice";

export const getUserWalletsApiSlice = API.injectEndpoints({
  endpoints: (builder) => ({
    getUserWallets: builder.query({
      query: () => {
        return {
          url: "users/get-wallets",
        };
      },
    }),
  }),
});

export const { useGetUserWalletsQuery } = getUserWalletsApiSlice;
